import { type  Edition, type Section, type Template, Topic, type TopicSection } from '../../restapi/types';
import { PreviewSection } from './PreviewSection';
import { allFixedTopicSections, allSectionsToOrder } from '../../restapi/document';


interface Props {
	edition: Edition;
	template?: Template;
}

const classNameForTopic = {
	[Topic.redAlert]: 'red-alert',
	[Topic.orangeAlert]: 'orange-alert',
	[Topic.yellowAlert]: 'yellow-alert',

	[Topic.highlights]: '',
	[Topic.l3emergency]: '',
	[Topic.l2emergency]: '',
	[Topic.monitoring]: '',
	[Topic.other]: '',
	[Topic.naturalHazard]: '',

	// from Jan 2022
	[Topic.scaleUp]: '',
	[Topic.corporateAttention]: '',
	[Topic.actionResponse]: '',

	// from Jan 2026
	[Topic.corporatePreparedness]: '',
	[Topic.corporateScaleUp]: '',
	[Topic.corporateFocus]: '',
};

export const topicTitleExtra = {
	[Topic.highlights]: '',

	[Topic.l3emergency]: '(L3)',
	[Topic.l2emergency]: '(L2)',
	[Topic.monitoring]: '(Monitoring)',

	[Topic.redAlert]: '',
	[Topic.orangeAlert]: '',
	[Topic.yellowAlert]: '',

	[Topic.other]: '',
	[Topic.naturalHazard]: '',

	// from Jan 2022
	[Topic.scaleUp]: '(Corporate Scale-Up)',
	[Topic.corporateAttention]: '(Corporate Attention)',
	[Topic.actionResponse]: '(Early Action & Emergency Response)',

	// from Jan 2026
	[Topic.corporatePreparedness]: '(Corporate Preparedness)',
	[Topic.corporateScaleUp]: '(Corporate Scale-Up)',
	[Topic.corporateFocus]: '(Corporate Focus)',
};

function extractSectionsForPreview(ed: Edition): [TopicSection[], Section[]] {
	return [allFixedTopicSections(ed), allSectionsToOrder(ed)];
}

export function Preview({template: t, edition: ed}: Props) {
	const [fixedTopicSections, sortableSections] = extractSectionsForPreview(ed);

	return (
		<div className="box-main dedob-document email">
			<div dangerouslySetInnerHTML={{__html: t?.header || ''}}/>

			<div className="body">
				{/* fixed topic sections */}
				{fixedTopicSections.map(topicSection =>
					<div key={topicSection.topic}>
						{(topicSection.contentSet.length && (topicSection.topic !== Topic.highlights)) ?
							<h2 className={classNameForTopic[topicSection.topic]}>
								{topicSection.title}
							</h2> :
							null
						}

						{topicSection.subtitle &&
							<h3 className="alert-subtitle topic-source">{topicSection.subtitle}</h3>
						}

						{topicSection.contentSet.map(section =>
							<div key={section.id}>
								{(topicSection.topic !== Topic.highlights) &&
									<h3>
										<div className={`dedob-title-section ${section.topic}`}>
											{section.title} {topicTitleExtra[topicSection.topic]}
										</div>
									</h3>
								}

								<div className="dedob-content-section">
									<PreviewSection section={section}/>
									{section.subtitle ?
										<p className="subtitle topic-source">{section.subtitle}</p>
										: null}
								</div>
							</div>,
						)}
					</div>,
				)}

				{/* sortable sections */}
				{sortableSections.map(section =>
					<div key={section.id}>
						<h3>
							<div className={`dedob-title-section ${section.topic}`}>
								{section.title} {topicTitleExtra[section.topic]}
							</div>
						</h3>
						<div className="dedob-content-section">
							<PreviewSection section={section}/>
							<p className="subtitle topic-source">{section.subtitle}</p>
						</div>
					</div>,
				)}
			</div>

			<div dangerouslySetInnerHTML={{__html: t?.footer || ''}}/>
		</div>
	);
}
